import { ISOs } from 'utils/form/constants';
import { ISignupForm } from 'utils/form/types';
import { loadRegion } from 'utils/intl/region';

const initialFormState = ({
  regionIso,
  phoneNumber,
  enableSignupCommunicationsPreselection,
}: {
  regionIso: ISOs;
  phoneNumber?: string;
  enableSignupCommunicationsPreselection: boolean;
}): ISignupForm => ({
  email: '',
  name: '',
  phoneNumber: phoneNumber || '',
  zipcode: '',
  dob: '',
  country: regionIso || loadRegion(),
  agreesToTermsOfService: false,
  wantsPromotionalEmails: enableSignupCommunicationsPreselection,
});

export default initialFormState;
